export default function Helpers() {
  return (
    <group>
      <axesHelper args={[10, 10]} />
      <gridHelper />
    </group>
  );
}
